export const shadeBgStyles = (theme: any) => ({
  body: {
    color: '#B4C9FF',
  },
  '#root > div': {
    minHeight: '100vh'
  }
});
